import type { PublicMeterView } from "@next-platform/packages-ts-types";
import React, { memo, useMemo } from "react";

import Trans from "@/components/Trans/Trans";
import { cn } from "@/utils";

/** Dice meters hold 0 until their first roll. */
const NOT_ROLLED = "—";

type RulebookDiceValueProps = {
  meter: PublicMeterView;
  value: number;
  isLarge?: boolean;
  "data-testid"?: string;
};

/** "14 / d20" for a dice meter; a dash before the first roll. */
const RulebookDiceValue = ({ meter, value, isLarge = false, "data-testid": testId }: RulebookDiceValueProps) => {
  const sidesValues = useMemo(() => ({ sides: meter.sides ?? meter.max ?? "" }), [meter.sides, meter.max]);
  return (
    <span
      className={cn("inline-flex items-baseline gap-1 whitespace-nowrap font-semibold", isLarge ? "text-lg font-bold" : "text-xs")}
      data-testid={testId}
    >
      {value < 1 ? NOT_ROLLED : value}
      <span className={cn("font-medium text-gray-11", isLarge ? "text-sm" : "")}>
        <Trans i18nKey="chat:rulebook.hud.dice.sides" defaults="/ d{{sides}}" values={sidesValues} />
      </span>
    </span>
  );
};

export default memo(RulebookDiceValue);
